import React from 'react';

import { FeedbackRecognitionTemplateTypes } from 'Shared/constants/types';

import FeedbackFormSection from '../FeedbackFormSection/FeedbackFormSection';
import FeedbackFormFieldContainer from '../FeedbackFormFieldContainer/FeedbackFormFieldContainer';
import WpAlert from 'Wpds/components/alert/WpAlert';

type Props = {
  instructions?: string;
};

function FeedbackBlankTemplate({ instructions }: Props) {
  return (
    <FeedbackFormSection templateType={FeedbackRecognitionTemplateTypes.feedbackBlankTemplate}>
      {instructions && (
        <div className="mb-3">
          <WpAlert showIcon={false}>
            {instructions.split('\n').map(instructions_line => (
              <p>{instructions_line}</p>
            ))}
          </WpAlert>
        </div>
      )}
      <FeedbackFormFieldContainer
        title="Productive Feedback"
        textFieldName="likeThatText"
        videoFieldName="likeThatVideo"
        templateType={FeedbackRecognitionTemplateTypes.feedbackBlankTemplate}
      />
    </FeedbackFormSection>
  );
}

export default FeedbackBlankTemplate;
